import { TournamentMatchStage } from 'twain-sport-fe-mono';
import { ROUTES, SUB_ROUTES } from 'constants/routes';

export const routes = {
    game: (id: unknown) => {
        const gameRoute = `/${ROUTES.GAME}/${id}`;

        return {
            any: `${gameRoute}/*`,
            dynamic: (routeName: string) => `${gameRoute}/${routeName}`,
            howToPlay: `${gameRoute}/${SUB_ROUTES.HOW_TO_PLAY}`,
            participants: (code?: string) => {
                if (code) {
                    return `${gameRoute}/${SUB_ROUTES.PARTICIPANTS}/${code}`;
                }

                return `${gameRoute}/${SUB_ROUTES.PARTICIPANTS}`;
            },
            current: `${gameRoute}/${SUB_ROUTES.CURRENT}`,
            upcoming: `${gameRoute}/${SUB_ROUTES.UPCOMING}`,
            past: `${gameRoute}/${SUB_ROUTES.PAST}`,
            standings: (
                tournamentCode?: string,
                stage: TournamentMatchStage = TournamentMatchStage.GROUPS,
            ) => {
                if (tournamentCode) {
                    return `${gameRoute}/${SUB_ROUTES.STANDINGS}?tournamentCode=${tournamentCode}&stage=${stage}`;
                }

                return `${gameRoute}/${SUB_ROUTES.STANDINGS}`;
            },
            matchInfo: (matchCode?: string) => {
                if (matchCode) {
                    return `${gameRoute}/${SUB_ROUTES.MATCH_INFO}?matchCode=${matchCode}`;
                }
                return `${gameRoute}/${SUB_ROUTES.MATCH_INFO}`;
            },
            results: `${gameRoute}/${SUB_ROUTES.RESULTS}`,
        };
    },
    lobby: `/${ROUTES.LOBBY}`,
    integration: `/${ROUTES.INTEGRATION}`,
    betHistory: `/${ROUTES.BET_HISTORY}`,
};
